import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
    standalone: true,
    imports: [NgClass],
    selector: 'box',
    templateUrl: './box.html',
    styleUrls: ['./box.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoxComponent {
    @Input()
    selected = false;

    @Input()
    disabled = false;

    @Input()
    borderRadius = false;

    @Input()
    minWidth = false;
}
